import getSdkSession from './utils/getSdkSession';

const Account = {

    getSdkSession,

    async getAccount() {
        const sdkSession = await Account.getSdkSession();
        const account = await sdkSession.accountApi.getAccount();
        return account;
    },

    /**
     *
     * @access public
     * @desc Gets the user's stored email from the SDK.
     * The current email & password must be provided for verification.
     * @returns {Promise} Resolves with email string.
     *
     */
    async getEmail() {
        const attributes = await Account.getAttributes();
        return attributes.email;
    },

    async getAttribute(key) {
        if (!key || (typeof key !== 'string')) {
            throw new Error('You must pass an attribute string to getAttribute.');
        }

        const attributes = await Account.getAttributes();

        if (attributes[key] === undefined) {
            console.warn(`${key} attribute not found on account.`);
        }
        return attributes[key];
    },

    async getAttributes() {
        const account = await Account.getAccount();
        return account.attributes;
    },

    async setAttribute(key, newValue) {
        if ((typeof key !== 'string') || (newValue === undefined)) {
            throw new Error('You must pass an attribute string and a new value to setAttribute.');
        }
        const newAttribute = {};
        newAttribute[key] = newValue;
        return Account.setAttributes(newAttribute);
    },

    async setAttributes(newAttributes) {
        if (!newAttributes || (typeof newAttributes !== 'object')) {
            throw new Error('You must pass an object to setAttributes that contains the key/value pairs of attributes you want to update.');
        }
        const account = await Account.getAccount();
        const sdkSession = await Account.getSdkSession();
        const { accountApi } = sdkSession;
        for (const key in newAttributes) {
            if ({}.hasOwnProperty.call(newAttributes, key)) {
                account.attributes[key] = newAttributes[key];
            }
        }
        return accountApi.updateAccount(account);
    },

    async removeAttribute(key) {
        if ((typeof key !== 'string') || !key) {
            throw new Error('You must pass an attribute string to removeAttribute.');
        }
        const account = await Account.getAccount();
        const sdkSession = await Account.getSdkSession();
        const { accountApi } = sdkSession;
        account.attributes[key] = null;
        return accountApi.updateAccount(account);
    }

};

export default Account;
